import React from "react";

function SRReminderRate({ data, loading, error, onClick }) {
  const percentage = Number(data?.percentage || 0);
  const completed = Number(data?.completed || 0);
  const total = Number(data?.total || 0);

  const clickable = typeof onClick === "function";

  return (
    <div
      className={`dashboard-card-v2 ${clickable ? "dashboard-card-v2--clickable" : ""}`}
      onClick={clickable ? onClick : undefined}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={
        clickable
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }
    >
      <div className="dashboard-card-v2-header">
        <i className="fas fa-bell" />
        <span>My Reminder Completion Rate</span>
        <span className="dashboard-card-v2-count">
          Last {data?.windowDays || 30} days
        </span>
      </div>
      <div className="dashboard-card-v2-body">
        {error ? (
          <div className="dashboard-error">
            <i className="fas fa-exclamation-circle" /> {error}
          </div>
        ) : loading ? (
          <div className="dashboard-skeleton-block" style={{ height: 100 }} />
        ) : (
          <div className="sr-reminder-rate">
            <div className="sr-reminder-rate-bar">
              <div
                className="sr-reminder-rate-fill"
                style={{ width: `${percentage}%` }}
              />
            </div>
            <div className="sr-reminder-rate-labels">
              <strong>{percentage}%</strong>
              <span>
                {completed} of {total} on time
              </span>
            </div>
            {clickable && (
              <div className="dashboard-card-v2-footer-link dashboard-card-v2-footer-link--inline">
                View recent completed activities
                <i className="fas fa-arrow-right" />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default SRReminderRate;